module.exports = __webpack_public_path__ + "img/vector__one.0ac88abb.svg";